import { useEffect } from 'react'

// This hooks automatically finds if there is a saved annotation
// at the current time being played in the video. If there is, it selects it.
export default function useSetAnnotationFromProgress({
  setCurrentAnnotation,
  progress,
  isReadOnly,
  annotations,
}) {
  useEffect(() => {
    if (!progress || !isReadOnly || (progress && !progress.playedSeconds)) {
      return
    }

    const newCurrentAnnotation = annotations?.find((a, index) => {
      if (a.start <= progress.playedSeconds) {
        const nextAnnotation = annotations[index + 1]
        if (nextAnnotation && nextAnnotation.start <= progress.playedSeconds) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    })

    if (newCurrentAnnotation) {
      setCurrentAnnotation({
        ...newCurrentAnnotation,
        shouldSeek: false,
      })
    }
  }, [annotations, progress])
}
